import { assertNever, assertNotOptional } from '@wix/seo-common-core';
import { getComponentHeadingSource } from '../../common/utils/get-component-heading-source';
import { updateStructuredHeadingDataObject } from './helpers/update-structured-heading-data-object';
import { updateHtmlHeadingDataObject } from './helpers/update-html-heading-data-object';
export function updateComponentData(component, newTag) {
  const {
    id,
    type
  } = component;
  const headingSource = getComponentHeadingSource(type);
  const {
    data
  } = component;
  assertNotOptional(data, 'data');
  if (headingSource === 'HTML') {
    return updateHtmlHeadingDataObject(component, newTag);
  }
  if (headingSource === 'STRUCTURED') {
    return updateStructuredHeadingDataObject(component, newTag);
  }
  if (headingSource === 'UNKNOWN') {
    throw new Error(`Component ${id} with type ${type} is not supported`);
  }
  assertNever(headingSource);
}
//# sourceMappingURL=update-component-data.js.map